import { useState } from 'react'

export const useTaskModals = () => {
  // 任务详情抽屉
  const [view, setView] = useState<{ visible: boolean; id: string }>({ visible: false, id: '' })

  // 删除任务弹窗
  const [remove, setRemove] = useState<{ visible: boolean; id: string[]; type: string }>({
    visible: false,
    id: [],
    type: '',
  })

  // 创建报表弹窗
  const [report, setReport] = useState<{
    visible: boolean
    id: string | string[]
    name: string
    multiple?: boolean
    taskList?: { task_name: string; campaign_id: string }[]
    selectItem?: any
  }>({ visible: false, id: '', multiple: false, name: '', taskList: [], selectItem: null })

  // 任务复测弹窗
  const [retestVisible, setRetestVisible] = useState({
    visible: false,
    result_id: '',
    task_id: '',
  })

  // 查看任务详情
  const viewData = (id: string) => {
    setView({ visible: true, id })
  }

  // 关闭任务详情
  const closeView = () => {
    setView({ visible: false, id: '' })
  }

  // 打开删除弹窗
  const removeData = (id: string | string[], type: string) => {
    console.log('remove data', id)
    if (typeof id === 'string') {
      setRemove({ visible: true, id: [id], type })
    } else {
      setRemove({ visible: true, id, type })
    }
  }

  const reportData = (id: string, name: string) => {
    const taskList = [{ task_name: name, campaign_id: id }]
    setReport({ visible: true, id, name, taskList })
  }

  const closeReport = () => {
    setReport({ visible: false, id: '', name: '', taskList: [], selectItem: [], multiple: false })
  }

  return {
    view,
    setView,
    remove,
    setRemove,
    report,
    setReport,
    retestVisible,
    setRetestVisible,
    viewData,
    closeView,
    removeData,
    reportData,
    closeReport,
  }
}
